interface ThumbnailProps {
  /** Must be a valid CSS aspect ratio value, e.g. `"16/9"` or `1.5` */
  aspectRatio?: number | string;
  /** Array of badge texts to display */
  badges?: string[];
  /**
   * How the image should be sized relative to the thumbnail container. Matches
   * the behavior of the CSS `object-fit` and `background-size` properties.
   *
   * - `contain` will scale the image to fit within the container while
   *   maintaining its aspect ratio. If the aspect ratio of the image does not
   *   match the aspect ratio of the container, the image will be letterboxed
   *   or pillarboxed. **This is a good option for logos.**
   * - `cover` will scale the image to fill the container while maintaining its
   *   aspect ratio. If the aspect ratio of the image does not match the aspect
   *   ratio of the container, the image will be clipped to fit. **This is a
   *   good option for photos.**
   */
  fit?: 'contain' | 'cover';
  src: string;
}

export function Thumbnail ({
  aspectRatio = 16 / 9,
  fit = 'cover',
  badges,
  src,
}: ThumbnailProps) {
  return (
    <div
      className='relative border-gray-200 border-x last:border-b first:border-t last:rounded-b-2xl first:rounded-t-2xl bg-white'
      style={{
        aspectRatio,
        backgroundImage: `url(${src})`,
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: fit,
      }}
    >
      {badges && badges.length > 0 && (
        <div className='absolute top-4 left-4 flex gap-2'>
          {badges.map((badge, index) => (
            <span key={index} className='inline-block rounded-lg py-1 px-2 bg-white border-emphasis text-violet-500 body-bold'>
              {badge}
            </span>
          ))}
        </div>
      )}
    </div>
  )
}

Thumbnail.displayName = 'MarketplaceCard.Thumbnail'
